<template>
  <div>
    <v-snackbar
      v-for="(toast, index) in toasts"
      :key="`toast_${index}`"
      :timeout="toast.timeout"
      v-model="toast.showing"
      :color="toast.color"
      :style="{ 'margin-bottom': margin(index) }"
    >
      {{ toast.message }}
      <template v-slot:action>
        <v-btn icon @click="closeToast(toast)" color="pink">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Component, { mixins } from "vue-class-component";
import ToastStateMixin from "@/mixins/store/ToastStateMixin";

@Component
export default class Toasts extends mixins(ToastStateMixin) {
  margin(i: number): string {
    return i * 60 + 8 + "px";
  }
}
</script>

<style scoped></style>
